var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 21,
    viewBox: "0 0 155 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.844238,
    y: 0.65625,
    width: 153.92,
    height: 19.6875,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3362_15295",
    transform: "scale(0.0116279 0.0909091)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3362_15295",
    width: 86,
    height: 11,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFYAAAALCAYAAADlRnreAAADDUlEQVRIDc2Xa09TQRCGi/fiFUwQBVG5KCKKQREPKGDRGLX//6sfSPgDJu2h2+Qx7+lMs9mecywSjE2me5uZnfPu7Mxso9FoNIALPdjsQOYUIEvphJNV8ac/4CqwAWQ1tKV9JAtcBF7U8L4HHgMTxq++dM+ne6dj4GmNXul45DLAZWAz4l/wNbXAdVvb8nngLvAmkkm/+RXQLEDtBLK8TztnlPrQFgEHhYDvELXAHgMe8VXRlwjYlzV8sfw9+0AdguYXo21HusDSmHoLcIG1Ev6mKwambf2z2SGgv5bIxDarv9PIYSUEWl0RoxSgFQbATfqGaQt8s81W5BEVNB954L7xP6vglUfIwDX7oHGBdbnXFXrfmd510+sHLK/TjdKew1tZAuyM8RxW6F+09XaK0V+NDdgfwLVxFJj36yNulfEDy2bgaYF9a3JzFXoVJrRvCqw8dwr4DrRctgbYPeeJW+DKENg8ZykEMieFhYKieNuD7Z81oEUeqzgr70pJht9wI/5TYCcAxXYBPyNbzwTs0RHNENjt92mLiljrbRRzu/BRJ+LgxG10jWRUFSk23TSDFa/Fd14e2wI+lJDivPYd8Viza8HWt22cxlgPBfLsMv3DXFPgo+zoHuttmefmsFwIJH9KSpY4Uk/18Scz+IkZfN7AVh2uz1cBK6+VAyhnNGs81vVUtglE5zO0kkZGFFn9H4SCdWC2hFRayY5SYO3Q5QziUWKt8ljdiDL9cyY7SF7Hx0yGLnuhS0sVQkxFtWAVQ43HPqjIkl4hKIzEwHpVsFoh50koTV4CxnXG7ayB4nKnTl7uUsBts1XgOchebnko+HPyKmJsl31y2v2YkpgbYAe45AbELaDyQ8DVkeLSlAGgcqiO19fuG78OzufK2l3jOzOwpscP3vc6sPnxgeUXz+mQOYUOWUFRpdDrIYNLQY0+KH2BxONtoADJ+PXyUg0Z88R9ZefhK0j1r73ENB/zed+vtq6v5qa1T/rTy83W/YGgsk78D2NeJVVANmtN7R2tW2jQ3EbM730rt7Se/QbfAvQ2EVKbhwAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage2);
export default __webpack_public_path__ + "static/media/image-2.c7064e465137d5fd9c3980c60d4f90fc.svg";
export { ForwardRef as ReactComponent };